// polyfills
import "ts-polyfill/lib/es2015-core";
import "ts-polyfill/lib/es2015-iterable";
import "ts-polyfill/lib/es2015-promise";
import "ts-polyfill/lib/es2016-array-include";
import "ts-polyfill/lib/es2017-object";
import "ts-polyfill/lib/es2018-async-iterable"; // for-await-of

import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider } from "react-redux";

import App from "./App";
import { MessageReceiver } from "./containers/MessageReceiver";
import { store } from "./store";
import "./index.css";
import { sendError } from "./utils/sendError";

ReactDOM.render(
  <Provider store={store}>
    <div style={{ width: "100%" }}>
      <MessageReceiver />
      <App />
    </div>
  </Provider>,
  document.getElementById("friendbuy-widget-root") as HTMLElement
);

window.addEventListener("error", (error) => {
  sendError({
    category: "global",
    subCategory: error.error.message,
    name: error.error.name,
    payload: JSON.stringify({
      stack: error.error.stack,
    }),
  });
});
